module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "page-container"
  }, [_vm._v("404 page not found")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a192157","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/404/404.vue
// module id = 627
// module chunks = 1